import { getInitials } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarAvatar } from './SonarAvatar';
import { useStakeholderReference } from '@hooks';
export const StakeholderAvatar = ({ className, large, stakeholderId }) => {
    var _a;
    const { name } = useStakeholderReference(stakeholderId);
    const [firstName, lastName] = (_a = name === null || name === void 0 ? void 0 : name.split(' ')) !== null && _a !== void 0 ? _a : [];
    const initials = getInitials(firstName, lastName);
    return (React.createElement(SonarAvatar, { className: className, isPlaceholder: stakeholderId === -1, large: large }, initials));
};
